import { CalculationResult, DegreeType, MiluimPeriod, RightType } from "../types/general";
import { get28DaysHakala, getMomentRange } from "./appUtils";
import { DentalRightsConfig, SEMESTER_A_PERIOD_FOR_SHANA_C_AND_UP, dentalSpecialHakalot } from "./dentalConfig";
import { hakalotTerms } from "../terms/hakalotTerms";
import { RIGHTS_OF_200_DAYS, RIGHTS_OF_3_WEEK_FIRST, RIGHTS_OF_3_WEEK_SECOND, RIGHTS_OF_50_DAYS, SEMESTER_A_PERIOD, SEMESTER_B_PERIOD } from "./config";


export function calcRightsForDental(isInMiluim: boolean, degreeType: DegreeType, miluimRanges: MiluimPeriod[]): CalculationResult[] {
    return calcRightsAccordingDays(isInMiluim, degreeType, miluimRanges);
}


export function calcRightsAccordingDays(isInMiluim: boolean, degreeType: DegreeType, miluimRanges: MiluimPeriod[]): CalculationResult[] {
    var totalMiluimDays = 0;

    miluimRanges.forEach(range => {
        totalMiluimDays += getMomentRange(range.from, range.to).diff('days') + 1;
    });

    // let ovelapingSemesterDays = getOverlappingDaysNum(miluimRanges, degreeType);
    let overlapingShnatLimudimDays = getOverlappingDaysNum(miluimRanges, degreeType, true) // used for exams-hakalot for semster B too.

    let y = 0;
    let hakalotArray = [] as CalculationResult[];

    if (totalMiluimDays < 10) {
        return [];
    } else if (totalMiluimDays >= 10 && isInMiluim) {
        let examDoesntCount = {
            sum: -1,
            reason: hakalotTerms.TEN_DAYS_REASON,
            type: RightType.ExamDoesntCount
        }
        hakalotArray.push(examDoesntCount)
    }

    if (isInMiluim && totalMiluimDays >= 28) {
        hakalotArray.push(...get28DaysHakala());
    }

    if (isInMiluim && 
        [DegreeType.DentalBogerShanaA, DegreeType.DentalBogerShanaB, DegreeType.DentalBogerShanaC].
            includes(degreeType) &&
         totalMiluimDays >= 200) {
        hakalotArray.push(...get200DaysHakala(degreeType));
    }


    if (totalMiluimDays >= 42 && overlapingShnatLimudimDays >= 42) { // not with another case of 50 days
        // push case of 3 weeks 1 
        hakalotArray.push(...getWeeksOneHakalaForDental(isInMiluim, degreeType))

        // remove dublicated halakot (primary for shana D, E and F in !isInMiuim):
        let hakalotArrayOfSecond3Weeks = getWeeksTwoHakalaForDental(isInMiluim, degreeType);
        let zcootHakala = hakalotArrayOfSecond3Weeks[0];

        if (hakalotArray.find(h => isHalalotEqual(h, zcootHakala))) {
            hakalotArray.push(hakalotArrayOfSecond3Weeks[1])
        } else {
            // push case of 3 weeks 1 
            hakalotArray.push(...getWeeksTwoHakalaForDental(isInMiluim, degreeType))
        }
        y = 42;
    } else if (21 <= totalMiluimDays && overlapingShnatLimudimDays >= 21) {
        // push case of 3 weeks 1
        hakalotArray.push(...getWeeksOneHakalaForDental(isInMiluim, degreeType))
        y = 21;
    }

    let z = totalMiluimDays - y; // days reminds
    if (z >= 50) {
        // push case of 50 days
        hakalotArray.push(...get50DaysHakalaForDental(isInMiluim, degreeType))
    }

    if (isInMiluim && overlapingShnatLimudimDays >= 21) {
        let getHighestGrade = {
            sum: -1,
            reason: hakalotTerms.THREE_WEEKS_SHNAT_LIMNUDIM_REASON,
            type: RightType.HighestGrade
        }
        hakalotArray.push(getHighestGrade)
    }

    let binaryArr = hakalotArray.filter(c => c.type === RightType.Course);

    // remove all binaryCousre hakalot for take the highest binary
    hakalotArray = hakalotArray.filter(c => c.type !== RightType.Course);
    hakalotArray = hakalotArray.filter(c => c.sum !== 0);

    // takes the highest binary course number hakala:
    let max = 0;
    let maxBin = null as CalculationResult | null;
    binaryArr.forEach(b => {
        if (b.sum > max) {
            max = b.sum;
            maxBin = b;
        }
    })

    if (maxBin) {
        hakalotArray.push(maxBin);
    }

    if (hakalotArray.find(c => c.type === RightType.HighestGrade)) {
        hakalotArray = hakalotArray.filter(c => c.type !== RightType.ExamDoesntCount)
    }

    hakalotArray.sort((a, b) => a.type - b.type)
    return hakalotArray;
}

function isHalalotEqual(hakalaA: any, hakalaB: any): boolean {
    if (hakalaA.type === RightType.DentalRight && hakalaB.type === RightType.DentalRight) {
        if (hakalaA.dentalRightTitle === hakalaB.dentalRightTitle) {
            return true;
        }
    }
    return false;
}

export function getOverlappingDaysNum(miluimRanges: MiluimPeriod[], degreeType: DegreeType, includesSemesterB = false): number {
    var miluimMomentRanges = new Array();
    var sumOfOverlappingDays = 0; // with semster A

    miluimRanges.forEach(range => {
        miluimMomentRanges.push(getMomentRange(range.from, range.to))
    });

    let semesterAPeriod = SEMESTER_A_PERIOD;
    if (degreeType >= DegreeType.DentalBogerShanaC) {
        semesterAPeriod = SEMESTER_A_PERIOD_FOR_SHANA_C_AND_UP;
    }

    miluimMomentRanges.forEach(momentRange => {
        // console.log(config.SEMESTER_A_PERIOD);
        var overlapRange = momentRange.intersect(semesterAPeriod)
        if (overlapRange) {
            sumOfOverlappingDays += overlapRange.diff('days') + 1;
        }

        if (includesSemesterB) {
            var overlapRange = momentRange.intersect(SEMESTER_B_PERIOD)
            if (overlapRange) {
                sumOfOverlappingDays += overlapRange.diff('days') + 1;
            }
        }
    });
    // console.log(sumOfOverlappingDays);
    return sumOfOverlappingDays;
}

function getWeeksOneHakalaForDental(isInMiluim: boolean, degreeType: DegreeType): CalculationResult[] {
    let rightsMap = DentalRightsConfig;
    let hakalotMap = rightsMap.get(isInMiluim)!.get(degreeType)!.get(RIGHTS_OF_3_WEEK_FIRST);

    let zcoot = {} as CalculationResult;

    if (hakalotMap?.has(RightType.DentalRight)) {
        zcoot = {
            sum: -1,
            reason: hakalotTerms.THREE_WEEKS_FIREST_REASON,
            type: RightType.DentalRight,
            dentalRightTitle: dentalSpecialHakalot.get(hakalotMap!.get(RightType.DentalRight)!),
        };
    }
    else if (hakalotMap?.has(RightType.AvneyPina)) {
        zcoot = {
            sum: 2,
            reason: hakalotTerms.THREE_WEEKS_FIREST_REASON,
            type: RightType.AvneyPina
        };
    } else if (hakalotMap?.has(RightType.NekudotZehut)) {
        zcoot = {
            sum: hakalotMap!.get(RightType.NekudotZehut)!,
            reason: hakalotTerms.THREE_WEEKS_FIREST_REASON,
            type: RightType.NekudotZehut
        };
    }

    let course = {
        sum: hakalotMap!.get(RightType.Course)!,
        reason: hakalotTerms.THREE_WEEKS_FIREST_REASON,
        type: RightType.Course
    };

    let hakalot = [zcoot, course]

    return hakalot
}

export function get200DaysHakala(degreeType: DegreeType): CalculationResult[] {
    let noAttendanceRequired = {
        sum: -1,
        reason: hakalotTerms.FROM_200_AND_UP_REASON,
        type: RightType.NoAttendanceRequired
    };

    let intermediateAssignmentsPtor = {
        sum: -1,
        reason: hakalotTerms.FROM_200_AND_UP_REASON,
        type: RightType.IntermediateAssignmentsPtor
    };

    let hakalotMap = DentalRightsConfig.get(true)!.get(degreeType)!.get(RIGHTS_OF_200_DAYS);

    let ptorBinaryCourse = {
        sum: hakalotMap!.get(RightType.Course)!,
        reason: hakalotTerms.FROM_200_AND_UP_REASON,
        type: RightType.Course
    };

    return [noAttendanceRequired, intermediateAssignmentsPtor, ptorBinaryCourse]
}


function getWeeksTwoHakalaForDental(isInMiluim: boolean, degreeType: DegreeType): CalculationResult[] {
    let rightsMap = DentalRightsConfig;
    let hakalotMap = rightsMap.get(isInMiluim)!.get(degreeType)!.get(RIGHTS_OF_3_WEEK_SECOND);

    let zcoot = {} as CalculationResult;

    if (hakalotMap?.has(RightType.DentalRight)) {
        zcoot = {
            sum: -1,
            reason: hakalotTerms.THREE_WEEKS_SECOND_REASON,
            type: RightType.DentalRight,
            dentalRightTitle: dentalSpecialHakalot.get(hakalotMap!.get(RightType.DentalRight)!),
        };
    }
    else if (hakalotMap?.has(RightType.AvneyPina)) {
        zcoot = {
            sum: 2,
            reason: hakalotTerms.THREE_WEEKS_SECOND_REASON,
            type: RightType.AvneyPina
        };
    } else if (hakalotMap?.has(RightType.NekudotZehut)) {
        zcoot = {
            sum: hakalotMap!.get(RightType.NekudotZehut)!,
            reason: hakalotTerms.THREE_WEEKS_SECOND_REASON,
            type: RightType.NekudotZehut
        };
    }

    let course = {
        sum: hakalotMap!.get(RightType.Course)!,
        reason: hakalotTerms.THREE_WEEKS_SECOND_REASON,
        type: RightType.Course
    };

    return [zcoot, course]
}


function get50DaysHakalaForDental(isInMiluim: boolean, degreeType: DegreeType): CalculationResult[] {
    let rightsMap = DentalRightsConfig;
    let hakalotMap = rightsMap.get(isInMiluim)?.get(degreeType)?.get(RIGHTS_OF_50_DAYS);

    let zcoot = {} as CalculationResult;

    if (hakalotMap?.has(RightType.DentalRight)) {
        zcoot = {
            sum: -1,
            reason: hakalotTerms.FIFTY_DAYS_REASON,
            type: RightType.DentalRight,
            dentalRightTitle: dentalSpecialHakalot.get(hakalotMap!.get(RightType.DentalRight)!),
        };
    }
    else if (hakalotMap?.has(RightType.AvneyPina)) {
        zcoot = {
            sum: hakalotMap!.get(RightType.AvneyPina)!,
            reason: hakalotTerms.FIFTY_DAYS_REASON,
            type: RightType.AvneyPina
        };
    } else if (hakalotMap?.has(RightType.NekudotZehut)) {
        zcoot = {
            sum: hakalotMap!.get(RightType.NekudotZehut)!,
            reason: hakalotTerms.FIFTY_DAYS_REASON,
            type: RightType.NekudotZehut
        };
    }

    let course = {
        sum: hakalotMap!.get(RightType.Course)!,
        reason: hakalotTerms.FIFTY_DAYS_REASON,
        type: RightType.Course
    };

    return [zcoot, course]
}
